// //----------------10/01/2025----------------
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import "../Styles/FlightCard.css";

// const FlightCard = ({ flight, seatData , updatedPrice }) => {
//   console.log("Flight data:", flight);
//   console.log("Seat data:", seatData); // Log seat data for verification
// console.log("extraAmount :",updatedPrice);
//   const navigate = useNavigate();

//   // Use seatData as state
//   const [seats, setSeats] = useState({
//     adults: 0,
//     children: 0,
//     infants: 0,
//   });

//   // Initialize seat state on mount or when seatData changes
//   useEffect(() => {
//     if (seatData) {
//       setSeats(seatData);
//     }
//   }, [seatData]);

//   const airlineLogos = {
//     SpiceJet: "https://airiq.in/img/spicejet.png",
//     IndiGo: "https://airiq.in/img/indigo.png",
//     Vistara: "https://airiq.in/img/vistara.png",
//     AirIndia: "https://airiq.in/img/airindia.png",
//     AkasaAir:"https://airiq.in/img/akasaair.png"
//   };

//   const airlineLogo =
//     airlineLogos[flight.airline];

//   return (
//     <div className="flight-card">
//       <div className="flight-card-header">
//         <div style={{ textAlign: "center", margin: "10px 0" }}>
//           <img src={airlineLogo} alt={`${flight.airline}`} />
//           <h4 style={{ marginTop: "5px", fontSize: "0.9em", color: "#333" }}>
//             {flight.airline}
//           </h4>
//         </div>
//         <div className="flight-details">
//           <h4>
//             {flight.origin} → {flight.destination}
//           </h4>
//           <p className="flight-type">{flight.flight_route || "Flight Route"}</p>
//         </div>
//       </div>
//       <div className="flight-info">
//         <div className="flight-date">
//           <span>
//             {flight.departure_date
//               ? new Date(flight.departure_date).toDateString()
//               : "Departure Date"}
//           </span>
//         </div>
//         <div className="flight-time">
//           <span>{flight.flight_number || "Flight Number"}</span>
//           <span>
//             {flight.departure_time && flight.arival_time
//               ? `${flight.departure_time} - ${flight.arival_time}`
//               : "Flight Times"}
//           </span>
//         </div>
//       </div>
//       <div className="booking-section">
//         {/* <p className="seats-info">TOUR CODE</p> */}
//         {/* <h3>AP{flight.price}</h3> */}
//         {/* <h3>AP{Math.round(flight.price)}</h3> */}
//         <h3>INR{Math.round(flight.price)}</h3>


//       </div>
//       <div className="booking-section">
//         <button
//           className="book-now-button"
//           onClick={() =>
//             navigate(`/bookticket`, {
//               state: { flight, seats , updatedPrice }, // Pass seat data to the booking page
//             })
//           }
//         >
//           BOOK NOW
//         </button>
//         <p className="seats-info">
//           Seats: {flight.pax}
          
//         </p>
//       </div>
//     </div>
//   );
// };

// export default FlightCard;
//----------------10/01/2025----------------
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/FlightCard.css";

const FlightCard = ({ flight, seatData, updatedPrice }) => {
  const navigate = useNavigate();

  const [seats, setSeats] = useState({
    adults: 0,
    children: 0,
    infants: 0,
  });

  useEffect(() => {
    if (seatData) {
      setSeats(seatData);
    }
  }, [seatData]);

  const airlineLogos = {
    SpiceJet: "https://airiq.in/img/spicejet.png",
    IndiGo: "https://airiq.in/img/indigo.png",
    Vistara: "https://airiq.in/img/vistara.png",
    AirIndia: "https://airiq.in/img/airindia.png",
    AkasaAir: "https://airiq.in/img/akasaair.png",
  };

  const airlineLogo = airlineLogos[flight.airline];

  return (
    <div className="flight-card">
      {/* HEADER */}
      <div className="flight-card-header">
        <div style={{ textAlign: "center", margin: "10px 0" }}>
          <img src={airlineLogo} alt={flight.airline} />
          <h4 style={{ marginTop: "5px", fontSize: "0.9em" }}>
            {flight.airline}
          </h4>
        </div>

        <div className="flight-details">
          <h4>
            {flight.origin} → {flight.destination}
          </h4>
          <p className="flight-type">
            {flight.flight_route || "Flight Route"}
          </p>
        </div>
      </div>

      {/* INFO */}
      <div className="flight-info">
        <div className="flight-date">
          {flight.departure_date
            ? new Date(flight.departure_date).toDateString()
            : "Departure Date"}
        </div>

        <div className="flight-time">
          <span>{flight.flight_number || "Flight Number"}</span>
          <span>
            {flight.departure_time && flight.arival_time
              ? `${flight.departure_time} - ${flight.arival_time}`
              : "Flight Time"}
          </span>
        </div>
      </div>

      {/* PRICE */}
      <div className="booking-section">
        <h3>INR {Math.round(flight.price)}</h3>
      </div>

      {/* ACTION */}
      <div className="booking-section">
        <button
          className="book-now-button"
          onClick={() =>
            navigate("/bookticket", {
              state: { flight, seats, updatedPrice },
            })
          }
        >
          BOOK NOW
        </button>

        <p className="seats-info">Seats: {flight.pax}</p>
      </div>
    </div>
  );
};

export default FlightCard;
